// Fase 6 i18n bundle — Estatísticas · Monitorización · Anonimización
import i18n from "@/i18n";

const GL = {
  sidebar_monitoring: "Monitorización",
  sidebar_stats: "Estatísticas de uso",

  // Estatísticas públicas
  stats_title: "Estatísticas de uso",
  stats_subtitle: "Consultas á API pública de Datos Abertos · Últimos 30 días",
  stats_kpi_requests: "Consultas 30 días",
  stats_kpi_orgs: "Organizacións activas",
  stats_kpi_datasets: "Datasets consultados",
  stats_top_datasets: "Top datasets",
  stats_evolution: "Evolución (30 días)",
  stats_map_title: "Consultas por país",
  stats_orgs_title: "Organizacións con API key",
  stats_th_org: "Organización",
  stats_th_country: "País",
  stats_th_requests: "Consultas 30d",
  stats_th_first_seen: "Alta",
  stats_empty: "Aínda non hai actividade rexistrada. As primeiras consultas aparecerán aquí en breve.",
  stats_cta_key: "Solicitar API key",
  stats_cta_docs: "Documentación",

  // Monitorización
  mon_title: "Monitorización",
  mon_subtitle: "Métricas en tempo real da plataforma",
  mon_uptime: "Uptime",
  mon_requests_1h: "Consultas 1h",
  mon_error_rate: "% Erros 1h",
  mon_avg_latency: "Latencia media",
  mon_open_hits: "Open API 1h",
  mon_integrations_ok: "Integracións OK",
  mon_tasks_title: "Tarefas en background",
  mon_integrations_title: "Integracións externas",
  mon_rate_title: "Rate limits e top consumidores",
  mon_audit_title: "Eventos de auditoría (últimos 7 días)",
  mon_top_consumer: "Consultas 24h",
  mon_chart_line_title: "Consultas por hora · 24h",
  mon_chart_line_series: "Consultas",
  mon_chart_bar_title: "Top 5 datasets · 24h",
  mon_chart_bar_series: "Consultas",
  mon_chart_bar_empty: "Aínda non hai consultas rexistradas sobre datasets da API pública.",

  // Anonimización — drawer + admin
  anon_notice_gl: "Imaxe anonimizada por IA · {{faces}} rostros e {{plates}} matrículas difuminadas · Modelo: {{model}}",
  anon_admin_title: "Anonimización IA",
  anon_admin_stats: "Estatísticas de procesamento",
  anon_admin_reprocess: "Reprocesar todas as imaxes",
  anon_stats_total: "Procesadas",
  anon_stats_faces: "Rostros ocultos",
  anon_stats_plates: "Matrículas ocultas",
  anon_stats_errors: "Erros",

  // Signature verify
  sig_verify: "Verificar selo público",
  sig_backend: "Backend selo",
  sig_signer: "Firmante",
};

const ES = {
  sidebar_monitoring: "Monitorización",
  sidebar_stats: "Estadísticas de uso",

  stats_title: "Estadísticas de uso",
  stats_subtitle: "Consultas a la API pública de Datos Abiertos · Últimos 30 días",
  stats_kpi_requests: "Consultas 30 días",
  stats_kpi_orgs: "Organizaciones activas",
  stats_kpi_datasets: "Datasets consultados",
  stats_top_datasets: "Top datasets",
  stats_evolution: "Evolución (30 días)",
  stats_map_title: "Consultas por país",
  stats_orgs_title: "Organizaciones con API key",
  stats_th_org: "Organización",
  stats_th_country: "País",
  stats_th_requests: "Consultas 30d",
  stats_th_first_seen: "Alta",
  stats_empty: "Aún no hay actividad registrada. Las primeras consultas aparecerán aquí en breve.",
  stats_cta_key: "Solicitar API key",
  stats_cta_docs: "Documentación",

  mon_title: "Monitorización",
  mon_subtitle: "Métricas en tiempo real de la plataforma",
  mon_uptime: "Uptime",
  mon_requests_1h: "Consultas 1h",
  mon_error_rate: "% Errores 1h",
  mon_avg_latency: "Latencia media",
  mon_open_hits: "Open API 1h",
  mon_integrations_ok: "Integraciones OK",
  mon_tasks_title: "Tareas en background",
  mon_integrations_title: "Integraciones externas",
  mon_rate_title: "Rate limits y top consumidores",
  mon_audit_title: "Eventos de auditoría (últimos 7 días)",
  mon_top_consumer: "Consultas 24h",
  mon_chart_line_title: "Consultas por hora · 24h",
  mon_chart_line_series: "Consultas",
  mon_chart_bar_title: "Top 5 datasets · 24h",
  mon_chart_bar_series: "Consultas",
  mon_chart_bar_empty: "Aún no hay consultas registradas sobre datasets de la API pública.",

  anon_notice_gl: "Imagen anonimizada por IA · {{faces}} rostros y {{plates}} matrículas difuminadas · Modelo: {{model}}",
  anon_admin_title: "Anonimización IA",
  anon_admin_stats: "Estadísticas de procesamiento",
  anon_admin_reprocess: "Reprocesar todas las imágenes",
  anon_stats_total: "Procesadas",
  anon_stats_faces: "Rostros ocultos",
  anon_stats_plates: "Matrículas ocultas",
  anon_stats_errors: "Errores",

  sig_verify: "Verificar sello público",
  sig_backend: "Backend sello",
  sig_signer: "Firmante",
};

i18n.addResourceBundle("gl", "common", { fase6: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase6: ES }, true, true);

export default {};
